export default {
  ecommerce: {
    baseURL: process.env.API_URL,
    mock: {
      enabled: false,
      delay: 1000, // response delay in milliseconds
    },
  }
}
